import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, TEL_HREF, EMAIL_ADDRESS, SITE_URL, LOGO_URL } from "@/constants/site";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-burgundy text-cream overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 pt-20 pb-10">
        <Reveal>
          <img src={LOGO_URL} alt="Logo La Cantina del Barone" className="w-16 h-16 rounded-full shadow-[0_0_25px_rgba(198,156,78,0.25)] mb-8" />
          <p className="font-serif font-semibold leading-[0.95] tracking-tight text-[clamp(2.4rem,7vw,5.5rem)]">
            La Cantina <span className="italic text-gold">del Barone</span>
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-3 gap-10">
          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-gold">{t.footer.tagline}</p>
          </div>
          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-gold mb-4">{t.footer.anchors}</p>
            <ul className="space-y-2.5 text-sm">
              {[
                ["#chi-siamo", t.nav.about],
                ["#menu", t.nav.menu],
                ["#perche-noi", t.nav.highlights],
                ["#prenota", t.nav.cta],
                ["#contatti", t.nav.contacts],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="text-cream/70 hover:text-gold transition-colors" data-testid={`footer-anchor-${href.slice(1)}`}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-gold mb-4">{t.footer.contacts}</p>
            <ul className="space-y-2.5 text-sm text-cream/70">
              <li>
                <a href={TEL_HREF} className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-phone-link">
                  <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL_ADDRESS}`} className="inline-flex items-center gap-2 hover:text-gold transition-colors" data-testid="footer-email-link">
                  <Mail className="w-4 h-4" /> {EMAIL_ADDRESS}
                </a>
              </li>
              <li className="inline-flex items-center gap-2">
                <MapPin className="w-4 h-4" /> Cefalù (PA)
              </li>
              <li>
                <a href={SITE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-testid="footer-site-link">
                  www.lacantinadelbarone.it
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-cream/10 pt-6 flex flex-col sm:flex-row gap-3 justify-between text-xs text-cream/45">
          <p>© {year} La Cantina del Barone · Cefalù — {t.footer.rights}</p>
          <p>{t.footer.legal}</p>
        </div>
      </div>
    </footer>
  );
};
